import en from '@/i18n/lang/en/en'
import Layout from '@/views/layout/layout'


let routeName = en.routeName
export default [
    {
      path: '/flow',
      component: () => import('@/views/flow-center/index.vue'),
      name: 'flow',
      hiddenFlag: 'Y',
      meta: {
        title: '待办中心'  // 添加页面标题
      },
      children: []
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/flow/flow.js